import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { useMemo } from 'react';

import {
  OperationArchivesContainer,
  SearchSchema,
} from '@/features/operation-archives';

import { useGetOperationPackages } from '../-query';

import { useLaborCoreArchives } from './-query';

export const Route = createFileRoute('/_staff/labor-core/_packages/archives/')({
  component: LaborCoreArchives,
  validateSearch: zodValidator(SearchSchema),
});

function LaborCoreArchives() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  const archivesQuery = useLaborCoreArchives({
    page: search.pageIndex + 1,
    pageSize: search.pageSize,
    textSearch: search.textSearch,
    operationPackageId: search.operationPackageId,
    anchorDateFrom: search.anchorDateFrom,
    anchorDateTo: search.anchorDateTo,
    orderBy: search.orderBy,
    orderDirection: search.orderDirection,
  });

  const { data: operationPackagesData, isLoading: isOperationPackagesLoading } =
    useGetOperationPackages();

  const packageOptionsQuery = useMemo(
    () => ({
      data: operationPackagesData?.map((pkg) => ({
        id: pkg.operationPackageId,
        name: pkg.name,
      })),
      isPending: isOperationPackagesLoading,
    }),
    [operationPackagesData, isOperationPackagesLoading],
  );

  return (
    <OperationArchivesContainer
      searchParams={search}
      onNavigate={navigate}
      archivesQuery={archivesQuery}
      packageOptionsQuery={packageOptionsQuery}
      onRowClick={(row) => {
        navigate({
          to: `/labor-core/operation-packages/${row.packageId}/patterns/${row.patternId}/instances/${row.instanceId}`,
        });
      }}
    />
  );
}
